
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {

    display: block
}

.provider-detail {

    font-family: var(--ff-body)
}

.term {

    font-size: var(--fs-base);

    line-height: var(--lh-base);

    font-weight: var(--fw-medium);

    color: var(--primary-blue)
}

.description {

    font-size: var(--fs-base);

    line-height: var(--lh-base);

    color: var(--neutral-gray-1)
}

@media (min-width: 768px) {

    .description {

        font-size: var(--fs-lg);

        line-height: var(--lh-lg)
    }
}
`;